import { FAIR_TZ, toTs } from '@jobfair/shared';

/** "יום שני, 30 בנובמבר 2026" for a YYYY-MM-DD fair date. */
export function heDate(date: string, opts?: Intl.DateTimeFormatOptions): string {
  const t = toTs(date, '12:00');
  if (!Number.isFinite(t)) return '—';
  return new Date(t).toLocaleDateString('he-IL', {
    timeZone: FAIR_TZ,
    ...(opts ?? { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' }),
  });
}

export function fmtParts(ms: number) {
  const s = Math.max(0, Math.floor(ms / 1000));
  return {
    d: Math.floor(s / 86400),
    h: Math.floor((s % 86400) / 3600),
    m: Math.floor((s % 3600) / 60),
    sec: s % 60,
  };
}

/** "MM:SS" from milliseconds, never negative. */
export function mmss(ms: number): string {
  const total = Math.max(0, Math.floor(ms / 1000));
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
}

/** Accent color slot (--c0..--c5) for a domain, by its position in the admin-managed list. */
export const domainColor = (domains: string[], d: string): string => {
  const i = domains.indexOf(d);
  return `var(--c${i < 0 ? 5 : i % 5})`;
};

/** Stable 0-3 pick for decorative variants. */
export const hashIdx = (id: string): number =>
  [...String(id)].reduce((a, c) => a + c.charCodeAt(0), 0) % 4;

export async function copyText(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}
